(function($){
	var translationSettings = null;
	
	var initSettings = function(){
		translationSettings = new Object();
		$('[data-role="tanslation_phrase"]').each(function(){
			translationSettings[$(this).data("phrase")] = $(this).text();
		});
	};
	
	OH.attributeTranslation = function($target, attributeName){
		if(!translationSettings){
			initSettings();
		}
		var currentPhrase = $target.attr(attributeName);
		$target.attr(attributeName, translationSettings[currentPhrase] || currentPhrase);
	};

})(jQuery);